var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "root", staticClass: "wkb-tree-graph" }, [
    _vm.hoverTooltip.visible
      ? _c(
          "div",
          { staticClass: "wkb-tree-graph-tooltip", style: _vm.tooltipStyle },
          [_vm._v(" " + _vm._s(_vm.hoverTooltip.text) + " ")]
        )
      : _vm._e(),
    _c("svg", {
      ref: "svg",
      staticClass: "wkb-tree-graph-svg",
      attrs: { "aria-label": "Knowledge graph tree view" },
    }),
    _vm.showEmptyMessage && !_vm.graphNodes.length
      ? _c("p", { staticClass: "wkb-tree-graph-empty" }, [
          _vm._v(" No nodes to display. "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }